import { IChat, IMessage } from '@v2/domains/chat/types/chat.types'

import { ITask, MutateTaskData } from '../task.types'

export const transformUpdateTaskFormValues = (
  selectedItemValues: Partial<ITask>,
  showLastMessageOnly = true,
) => {
  const {
    person,
    type,
    action,
    subject,
    assignedTo,
    activityDate,
    createdAt,
    updatedAt,
    chat,
    priority,
    status,
    createdBy,
    updatedBy,
    id,
  } = selectedItemValues
  const transformedValues: MutateTaskData & { notes?: IMessage[] } = {
    id,
    person,
    type,
    action,
    subject,
    priority,
    status,
    createdBy,
    updatedBy,
  }

  if (activityDate) {
    transformedValues.activityDate = new Date(activityDate)
  }
  if (createdAt) {
    transformedValues.createdAt = new Date(createdAt)
  }
  if (updatedAt) {
    transformedValues.updatedAt = new Date(updatedAt)
  }
  if (assignedTo) {
    transformedValues.assignedToId = assignedTo.id
  }

  if (chat) {
    const chatCopy: IChat = JSON.parse(JSON.stringify(chat))
    let note = ''
    let notes = [] as IMessage[] | []
    if (chat.messages.length) {
      notes = chatCopy.messages.sort((messageA, messageB) => {
        if (
          new Date(messageA.createdAt).getTime() >
          new Date(messageB.createdAt).getTime()
        ) {
          return -1
        }
        return 1
      })
      note = notes[0].message
    }
    transformedValues.note = note as string
    if (!showLastMessageOnly) {
      transformedValues.notes = notes
    }
  }

  return transformedValues
}
